import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { setRem } from '@/libs/js/setRem'
import './libs/styles/reset.less'
import './assets/fonts/icon-font.less'
import axios from 'axios'
Vue.prototype.$axios = axios
Vue.config.productionTip = false
setRem(750, 100)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

